import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@liberty-financial/ng-components';

import { SparkSharedPaginationComponent } from './pagination.component';

@NgModule({
  declarations: [SparkSharedPaginationComponent],
  imports: [CommonModule, ButtonModule],
  exports: [SparkSharedPaginationComponent]
})
export class SparkSharedPaginationModule {}
